import { SearchSuggestion } from '@/api/types/searchSuggestions.types';

export interface SearchSuggestionsProps {
  searchQuery: string;
  suggestions: SearchSuggestion[];
  onSelect: (suggestion: SearchSuggestion) => void;
  offsetLeft?: number;
}

export enum KeywordsSource {
  Suggestion = 'search_suggestion',
  Typewritten = 'typewritten',
}
